import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Obama wins",
  "description": "",
  "published": "2008-11-04T00:00:00.000Z",
  "redirect_from": ["/blog/obama-wins/swizec/46"],
  "categories": "commentary, food for thought",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The twitter crowd in america seems to be saying that Obama has won the election and the world now has a black president. Yay, hooray. Notice I said the world not the US, that's the bad connotations right there, seriously, the US has way too much power and if I know anything about politics no Obama will ever change that, in fact I'd say he'll try and give his country even more power.`}</p>
    <p>{`Difficult to tell right now whether anything will really change now that Obama took the rein, but time will tell. He certainly was saying some pretty good things in the race to power, I mean votes. Must say I've never seen anyone deliver speeches as well since Hitler, in fact, I'd venture to say he's the most informed and thinking politician I've seen in my life time, almost certainly the best we've had on the scene since the likes of Roosevelt, Churchill, Hitler and Kennedy.`}</p>
    <p>{`But I fear that no matter how awesome Obama may be, unless he finds a way to become an absolutist he'll never be able to change anything since Money is still where the power lies in the US.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      